import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { authConfig } from "./authconfig";
import { reactPlugin } from "./appinsights";
import { MsalProvider } from "@azure/msal-react";
import { Provider as ReduxProvider } from "react-redux";
import store from "./store/store";

export const msalInstance = new PublicClientApplication(authConfig);

async function initializeMsal() {
  await msalInstance.initialize(); // Ensure initialization is complete
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
  msalInstance.addEventCallback(msalEventCallback);
}

initializeMsal();

const msalEventCallback = (event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload !== null &&
    event.payload !== undefined
  ) {
    const e = event.payload; // typedef incorrect
    const account = e.account;
    if (account !== null && account !== undefined) {
      msalInstance.setActiveAccount(account);
    }
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppInsightsContext.Provider value={reactPlugin}>
      <MsalProvider instance={msalInstance}>
        <ReduxProvider store={store}>
          <App />
        </ReduxProvider>
      </MsalProvider>
    </AppInsightsContext.Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
